import { Separator } from '@talentmesh/ui/components/separator';
import { useUserContext } from '@/Context/UserContext';

const ProfileMenuHeader = () => {
    const { user } = useUserContext();
    const displayName = user.firstName.length > 25 ? `${user.firstName.slice(0, 25)}…` : user.firstName;

    return (
        <div className="pb-1">
            <div className="flex w-full flex-col gap-0.5 px-2 py-2.5">
                <p className="text-foreground truncate text-sm font-bold" title={user.firstName}>
                    {displayName}
                </p>
                {user.role ? <p className="text-muted-foreground truncate text-xs">{user.role}</p> : null}
            </div>
            <Separator />
        </div>
    );
};

export default ProfileMenuHeader;
